(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PharmaReceptionServiceByVat', PharmaReceptionServiceByVat);

	PharmaReceptionServiceByVat.$inject = [ '$resource' ];

	function PharmaReceptionServiceByVat($resource) {
		var resourceUrl = 'api/pharmaReceptionServiceByVat/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'save' : {
				method : 'POST',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {

						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();
